import { px2rem } from '@sk/sk-ui-sdk/lib/sk-utils/lib/rem'
import Lodash from 'lodash'

import lang from '@/lang'
import dictionary from '@/utils/dictionary'

const FormUtil = {
  updateValue(that, $id, value) {
    try {
      let formValue = that.$refs.renderForm['value']
      if (formValue.hasOwnProperty($id)) {
        formValue[$id] = value
      } else {
        for (let keyStr in formValue) {
          if (formValue[keyStr] && formValue[keyStr].hasOwnProperty($id)) {
            formValue[keyStr][$id] = value
            break
          }
        }
      }
      // 有表单组，此方法不适用
      // that.$refs['renderForm']['updateValue']({ id: $id, value: value })
    } catch (e) {
      console.log(e)
    }
  },
  validate(that, field = '', nextTick = true) {
    try {
      const doValidate = () => {
        if (field) {
          that.$refs['renderForm']['validateField'](field)
        } else {
          that.$refs['renderForm']['validate']()
        }
      }
      if (nextTick) {
        that.$nextTick(() => doValidate())
      } else {
        doValidate()
      }
    } catch (e) {
      console.log(e)
    }
  },
  clearValidate(that, props = '', nextTick = true) {
    try {
      const doClear = () => {
        if (props || props.length > 0) {
          // element-ui支持单项校验清除，但是sk的element-ui此方法不支持清除单项校验
          // that.$refs.renderForm['clearValidate'](props)
          let formFields = that.$refs.renderForm.$refs.elForm['fields']
          const fields = props.length
            ? typeof props === 'string'
              ? formFields.filter(field => props === field.prop)
              : formFields.filter(field => props.indexOf(field.prop) > -1)
            : formFields
          fields.forEach(field => {
            field.clearValidate()
          })
        } else {
          that.$refs.renderForm['clearValidate']()
        }
      }
      if (nextTick) {
        that.$nextTick(() => doClear())
      } else {
        doClear()
      }
    } catch (e) {
      console.log(e)
    }
  },
  transDict(key, value) {
    let text = ''
    try {
      text = lang['t'](dictionary[key][value].label)
    } catch (e) {
      console.log(e)
    }
    return text
  },
  /**
   * 根据唯一值获取所在对象
   * @param metaData
   * @param value
   * @param defaultKey
   * @return {any}
   */
  getItemByKey(metaData, value, defaultKey = '$id') {
    try {
      let itemIsExist = false
      if (Lodash['isArray'](metaData)) {
        for (let i = 0; i < metaData.length; i++) {
          const obj = metaData[i]
          itemIsExist = FormUtil.getItemByKey(obj, value, defaultKey)
          if (itemIsExist) {
            break
          }
        }
      } else {
        for (const pro in metaData) {
          if (itemIsExist) {
            break
          }
          if (metaData[defaultKey] === value) {
            itemIsExist = metaData
            break
          } else if (Lodash['isPlainObject'](metaData[pro])) {
            itemIsExist = FormUtil.getItemByKey(metaData[pro], value, defaultKey)
          } else if (Lodash['isArray'](metaData[pro])) {
            for (let i = 0; i < metaData[pro].length; i++) {
              const obj = metaData[pro][i]
              itemIsExist = FormUtil.getItemByKey(obj, value, defaultKey)
              if (itemIsExist) {
                break
              }
            }
          }
        }
      }
      return itemIsExist
    } catch (e) {
      console.log(e)
      return false
    }
  },
  getValue(that, field = '') {
    try {
      let formValue = that.$refs.renderForm['value']
      if (field) {
        const doPlainObject = keyStr => {
          if (Lodash['isPlainObject'](formValue[keyStr])) {
            if (formValue[keyStr].hasOwnProperty(field)) {
              return formValue[keyStr][field]
            }
          }
        }
        const doArray = keyStr => {
          if (Lodash['isArray'](formValue[keyStr])) {
            for (let fdx = 0; fdx < formValue[keyStr].length; fdx++) {
              let fItem = formValue[keyStr][fdx]
              for (let itemKey in fItem) {
                if (!fItem[itemKey]) {
                  continue
                }
                if (fItem.hasOwnProperty(field)) {
                  return fItem[itemKey]
                }
                break
              }
            }
          }
        }

        if (formValue.hasOwnProperty(field)) {
          return formValue[field]
        } else {
          for (let keyStr in formValue) {
            let objResult = doPlainObject(keyStr)
            if (objResult) return objResult

            // TODO 表单中，自定义组件云桌面放的数据结构是数组
            let arrayResult = doArray(keyStr)
            if (arrayResult) return arrayResult
          }
        }
        return null
      } else {
        return formValue
      }
    } catch (e) {
      console.log(e)
      return null
    }
  },
  getFormOffset(that) {
    let defaultLabelWidth = '120px'
    try {
      let offsetResult = ''
      let renderForm = that.$refs.renderForm
      let labelWidth = renderForm['labelWidth']
      if (labelWidth) {
        offsetResult = px2rem(`-${labelWidth}`)
      } else {
        offsetResult = px2rem(`-${defaultLabelWidth}`)
      }
      return {
        marginLeft: offsetResult
      }
    } catch (e) {
      console.log(e)
      return {
        marginLeft: px2rem(`-${defaultLabelWidth}`)
      }
    }
  }
}

export default FormUtil
